interface BillingThresholds {
  amt_gte: number;
  reset_billing_cycle_anchor: boolean;
}

export interface StripeProduct {
  id: string;
  object: 'product';
  active: boolean;
  created: number;
  default_price: string;
  description: string;
  images: string[];
  livemode: boolean;
  metadata: {};
  name: string;
  package_dimensions: {
    height: number;
    length: number;
    weight: number;
    width: number;
  };
  shippable: boolean;
  statement_descriptor: string;
  tax_code: string;
  unit_label: string;
  updated: number;
  url: string;
}

export interface StripePrice {
  id: string;
  object: string;
  active: boolean;
  billing_scheme: string;
  created: number;
  currency: string;
  custom_unit_amount: {
    maximum: number;
    minimum: number;
    preset: number;
  };
  livemode: boolean;
  lookup_key: string;
  metadata: Record<string, unknown>;
  nickname: string;
  product: string;
  recurring: {
    aggregate_usage: string;
    interval: 'day' | 'week' | 'month' | 'year';
    interval_count: number;
    usage_type: string;
  };
  tax_behavior: string;
  tiers_mode: string;
  transform_quantity: {
    divide_by: number;
    round: 'up' | 'down';
  };
  type: string;
  unit_amount: number;
  unit_amount_decimal: string;
}

export interface StripeSubscription {
  product: any;
  id: string;
  object: string;
  application?: null;
  application_fee_percent?: null;
  automatic_tax: {
    enabled: boolean;
  };
  billing_cycle_anchor: number;
  billing_thresholds?: BillingThresholds;
  cancel_at?: number;
  cancel_at_period_end: boolean;
  canceled_at?: number;
  cancellation_details: {
    comment?: null;
    feedback?: null;
    reason?: null;
  };
  collection_method: string;
  created: number;
  currency: string;
  current_period_end: number;
  current_period_start: number;
  customer: string;
  days_until_due?: null;
  default_payment_method?: null;
  default_source?: null;
  default_tax_rates: [];
  description?: null;
  discount?: null;
  ended_at?: null;
  items: {
    object: 'list';
    data: [
      {
        id: string;
        object: string;
        billing_thresholds?: BillingThresholds;
        created: number;
        metadata: {};
        price: StripePrice;
        quantity: 1;
        subscription: string;
        tax_rates: [];
      }
    ];
    has_more: boolean;
    url: string;
  };
  latest_invoice: string;
  livemode: boolean;
  metadata: {
    Vehicles: string;
  };
  next_pending_invoice_item_invoice?: null;
  on_behalf_of?: null;
  pause_collection?: null;
  payment_settings: {
    payment_method_options?: null;
    payment_method_types?: null;
    save_default_payment_method: string;
  };
  pending_invoice_item_interval?: null;
  pending_setup_intent: string;
  pending_update?: null;
  schedule?: null;
  start_date: number;
  status: string;
  test_clock?: null;
  transfer_data?: null;
  trial_end: number;
  trial_settings: {
    end_behavior: {
      missing_payment_method: string;
    };
  };
  trial_start: number;
}
